import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

interface LoadingButtonProps {
  label: string;
  onClick: () => void;
  progress: number; // Percentage (0-100)
  type?: "primary" | "secondary"; // Button type
  disabled?: boolean;
  className?: string;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  label,
  onClick,
  progress,
  type = "primary", // Default to "primary"
  disabled = false,
  className = "",
}) => {
  const progressBarRef = useRef<HTMLDivElement>(null);

  const baseStyle = "btn-base";
  const primaryStyle = "btn-primary";
  const secondaryStyle = "btn-secondary";
  const disabledStyle = "btn-disabled";

  const style = `${baseStyle} ${
    type === "primary" ? primaryStyle : secondaryStyle
  } ${disabled ? disabledStyle : ""} ${className}`;

  useEffect(() => {
    // Animate the progress bar width based on `progress` prop
    if (progressBarRef.current) {
      gsap.to(progressBarRef.current, {
        width: `${progress}%`,
        duration: 0.5,
        ease: "power2.out",
      });
    }
  }, [progress]);

  return (
    <button
      onClick={disabled ? (e) => e.preventDefault() : onClick}
      disabled={disabled}
      className={`relative overflow-hidden ${style}`}
    >
      <span className="relative z-10">{label}</span>
      {/* White overlay at 30% opacity */}
      <div
        className="absolute top-0 left-0 h-full bg-white opacity-30 z-0"
        style={{ width: "100%" }}
      ></div>

      {/* Progress bar with ~40% transparency (opacity = 0.6) */}
      <div
        ref={progressBarRef}
        className="absolute top-0 left-0 h-full bg-primary z-0"
        style={{ width: "0%", opacity: 0.6 }}
      ></div>
    </button>
  );
};

export default LoadingButton;
